// Types
import { FiltersInterface, Sort } from "interfaces/osaSearch";

// Constants
import { ProductState, ReturnFields, SortingValue } from "constants/gpoSearchEnum";
import { QueryStringPrimaryKeys } from "constants/urlEnum";

interface SuggestionQueryParams {
	filters: FiltersInterface[];
	sorting: Sort[];
	pageOffset: number;
}

export const suggestionQueryParams: SuggestionQueryParams = {
	filters: [
		{
			fieldName: ReturnFields.PRODUCT_STATE,
			terms: [ProductState.NOTSTARTED_VALID, ProductState.ELEARNING_VALID]
		}
	],
	sorting: [
		{ FieldName: ReturnFields.PRODUCT_STATE, OrderValue: SortingValue.DESC },
		{ FieldName: ReturnFields.TITLE, OrderValue: SortingValue.ASC }
	],
	pageOffset: 1
};

export const queryStringKeys: QueryStringPrimaryKeys[] = [QueryStringPrimaryKeys.SEARCH, QueryStringPrimaryKeys.SHOW_NUMBER_PRODUCTS];
